import { buildProps } from '@ll-plus/utils'

import { SizeType } from 'ant-design-vue/es/config-provider'
import type { ExtractPropTypes } from 'vue'
import type Search from '../components/search.vue'

export const iconPickerSearchProps = buildProps({
  // buildProps和defineprops一样
  /**
   * @description icon的value
   */
  value: {
    type: String,
    default: '',
  },
  readonly: {
    type: Boolean,
  },

  // 尺寸
  size: {
    type: String as () => SizeType,
  },

  // 只显示图标
  showIconOnly: {
    type: Boolean,
    default: false,
  },
} as const)

// props
export type IconPickerSearchProps = ExtractPropTypes<
  typeof iconPickerSearchProps
>

// emits
export const iconPickerSearchEmits = {
  handleModal: (bool: boolean) => typeof bool === 'boolean',
  'update:value': (val: string) => typeof val === 'string',
  change: (val: string) => typeof val === 'string',
}

// instance
export type IconPickerSearchInstance = InstanceType<typeof Search>
